<!--
 * @Autor: Baowang
 * @Date: 2024-11-18 17:22:31
 * @pageName: 主页面
 * @LastEditTime: 2024-11-20 10:12:14
-->
<template>
  <div id="app">
    <publicTopVue />
    <router-view></router-view>
    <publicBottomVue :bgColor="$store.state.bgColor" />
  </div>
</template>
<script>
import publicBottomVue from "./components/public/publicBottom.vue"; //底部按钮样式
import publicTopVue from "./components/public/publicTop.vue";
export default {
  components: { publicBottomVue, publicTopVue },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less">
</style>
